/* PokeAlp : filtres de collection (desktop toggle + drawer mobile CardLab, multilingue via window.pokealpI18n) */
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.hdt-main-section__collection');
  if (!section) return;

  /* Fallbacks français si window.pokealpI18n n'est pas défini */
  var i18n = window.pokealpI18n || {};
  var t = {
    showFilters: i18n.showFilters || 'Afficher les filtres',
    hideFilters: i18n.hideFilters || 'Masquer les filtres',
    filterAndSort: i18n.filterAndSort || 'Filtrer et trier',
    seeResults: i18n.seeResults || 'Voir les résultats',
    seeResultsCount: i18n.seeResultsCount || 'Voir les résultats (__N__)'
  };
  function withCount(n) { return t.seeResultsCount.replace('__N__', n); }

  /* Idempotent : si déjà initialisé (par ex. depuis un ancien script inline), on nettoie */
  section.querySelectorAll('.pokealp-filter-toggle').forEach(function(el) { el.remove(); });
  document.querySelectorAll('.pokealp-mobile-filter-bar').forEach(function(el) { el.remove(); });

  var originalBtn = section.querySelector('.hdt-filter_btn');
  var sidebar = section.querySelector('aside.hdt-main-sidebar');
  var controlBar = section.querySelector('.hdt-shop-control');
  var drawer = document.getElementById('hdt-shop-sidebar-drawer');

  section.querySelectorAll('.hdt-sidebar-btn').forEach(function(b) { b.classList.add('pokealp-hidden-always'); });

  var mqDesktop = window.matchMedia('(min-width: 1150px)');

  /* === DESKTOP : toggle Afficher / Masquer les filtres === */
  if (sidebar && controlBar) {
    var flexParent = sidebar.closest('.hdt-row-flex');

    /* On ne cache l'aside qu'en desktop, sinon le <dialog> qu'il contient est bloqué en mobile */
    function syncSidebarDefault() {
      if (mqDesktop.matches) {
        sidebar.style.display = 'none';
        if (flexParent) flexParent.classList.remove('lg:hdt-flex-cols-2');
      } else {
        sidebar.style.display = '';
      }
    }
    syncSidebarDefault();
    mqDesktop.addEventListener('change', syncSidebarDefault);

    var deskBtn = document.createElement('button');
    deskBtn.type = 'button';
    deskBtn.className = 'pokealp-filter-toggle pokealp-desktop-only hdt-inline-flex hdt-align-center';
    deskBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" style="margin-right:8px"><path fill="currentColor" d="M324.4 64C339.6 64 352 76.37 352 91.63C352 98.32 349.6 104.8 345.2 109.8L240 230V423.6C240 437.1 229.1 448 215.6 448C210.3 448 205.2 446.3 200.9 443.1L124.7 385.6C116.7 379.5 112 370.1 112 360V230L6.836 109.8C2.429 104.8 0 98.32 0 91.63C0 76.37 12.37 64 27.63 64H324.4z"/></svg><span></span>';
    deskBtn.querySelector('span').textContent = t.showFilters;
    var filterCol = controlBar.querySelector('.hdt-control-filter');
    if (filterCol) filterCol.insertBefore(deskBtn, filterCol.firstChild);

    var open = false;
    deskBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (!mqDesktop.matches) return;
      open = !open;
      sidebar.style.display = open ? 'block' : 'none';
      if (flexParent) {
        if (open) flexParent.classList.add('lg:hdt-flex-cols-2');
        else flexParent.classList.remove('lg:hdt-flex-cols-2');
      }
      deskBtn.querySelector('span').textContent = open ? t.hideFilters : t.showFilters;
    }, true);
  }

  /* === MOBILE : barre fixe "Filtrer et trier" === */
  if (originalBtn) {
    originalBtn.classList.add('pokealp-hide-desktop');

    var mobileBar = document.createElement('div');
    mobileBar.className = 'pokealp-mobile-filter-bar';

    var mobileBtn = document.createElement('button');
    mobileBtn.type = 'button';
    mobileBtn.className = 'pokealp-mobile-filter-btn';
    mobileBtn.setAttribute('aria-controls', 'hdt-shop-sidebar-drawer');
    var icon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" style="margin-right:6px"><path fill="currentColor" d="M324.4 64C339.6 64 352 76.37 352 91.63C352 98.32 349.6 104.8 345.2 109.8L240 230V423.6C240 437.1 229.1 448 215.6 448C210.3 448 205.2 446.3 200.9 443.1L124.7 385.6C116.7 379.5 112 370.1 112 360V230L6.836 109.8C2.429 104.8 0 98.32 0 91.63C0 76.37 12.37 64 27.63 64H324.4z"/></svg>';
    mobileBtn.innerHTML = icon + '<span></span>';
    mobileBtn.querySelector('span').textContent = t.filterAndSort;

    mobileBar.appendChild(mobileBtn);
    document.body.appendChild(mobileBar);
  }

  /* === Drawer mobile : footer sticky "Voir les résultats (N)" style CardLab === */
  if (drawer) {
    function injectFooter() {
      var inner = drawer.querySelector('.hdt-dialog-drawer__inner');
      if (!inner || inner.querySelector('.pokealp-drawer-footer')) return;

      var footer = document.createElement('div');
      footer.className = 'pokealp-drawer-footer';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pokealp-see-results';
      btn.textContent = t.seeResults;
      footer.appendChild(btn);
      inner.appendChild(footer);

      btn.addEventListener('click', function() {
        var closeBtn = drawer.querySelector('.hdt-dialog-btn__close');
        if (closeBtn) { closeBtn.click(); return; }
        if (typeof drawer.close === 'function') drawer.close();
      });
    }

    function updateCount() {
      var btn = drawer.querySelector('.pokealp-see-results');
      if (!btn) return;
      var grid = section.querySelector('.hdt-collection-products');
      var n = grid ? grid.querySelectorAll('.hdt-card-product, [class*="hdt-pr-style"]').length : 0;
      var newText = n > 0 ? withCount(n) : t.seeResults;
      /* Garde fou : on ne réécrit que si le texte change, sinon on déclenche des mutations en boucle */
      if (btn.textContent !== newText) btn.textContent = newText;
    }

    /* Observer 1 : uniquement le changement de l'attribut "open" du <dialog>, PAS de subtree pour éviter les boucles infinies */
    new MutationObserver(function() {
      if (drawer.hasAttribute('open')) {
        injectFooter();
        updateCount();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });

    /* Observer 2 : quand la grille produits change (AJAX facets), on réinjecte le footer si besoin et on met à jour le compteur */
    var gridEl = section.querySelector('.hdt-collection-products');
    if (gridEl) {
      new MutationObserver(function() {
        injectFooter();
        updateCount();
      }).observe(gridEl, { childList: true });
    }

    /* Init au chargement */
    injectFooter();
    updateCount();
  }
});
